module.exports = __webpack_public_path__ + "fonts/Inter-700-greek49.3a3cf1a.woff2";